// extracted by mini-css-extract-plugin
module.exports = {"spacing":"BecomeAHost_spacing__YsOhk","heroContainer":"BecomeAHost_heroContainer__ugk3a"};